import React, { useState } from "react";

const Form = () => {
  const [sliderValue, setSliderValue] = useState(25);

  const handleSliderChange = (e) => {
    setSliderValue(Number(e.target.value));
  };

  return (
    <div>
      {/* Global Availability Section */}
      <section
        style={{
          padding: "60px 0",
          backgroundColor: "white",
          fontFamily: "sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            gap: 40,
          }}
        >
          {/* LEFT: AVAILABILITY */}
          <div style={{ flex: "1 1 45%" }}>
            <h2 style={{ color: "#222" }}>Global Availability</h2>
            <p style={{ lineHeight: "1.6", color: "#555" }}>
              We provide expert remote professionals to businesses across the
              US, UK, Canada, Australia, and Gulf countries. Our remote-first
              model guarantees timezone-aligned productivity and global reach.
            </p>
            <img
              src="assets/images/flag/world-map1.png"
              alt="Global Map"
              style={{ width: "100%", maxWidth: 500, marginTop: 20 }}
            />
          </div>

          {/* RIGHT: PRICING & PERKS */}
          <div style={{ flex: "1 1 45%" }}>
            <h2 style={{ color: "#222" }}>Affordable Pricing</h2>
            <p style={{ lineHeight: "1.6", color: "#555" }}>
              Save over 70% compared to in-house hiring. No infrastructure, no
              overhead, no lock-in — just remote experts, ready to go.
            </p>
            <ul style={{ listStyle: "none", paddingLeft: 0, color: "#333" }}>
              {[
                "Role-specific onboarding",
                "Weekly reporting & check-ins",
                "Free replacements if needed",
                "Dedicated account manager",
                "No long-term contracts",
                "Transparent monthly pricing",
              ].map((perk, index) => (
                <li key={index}>
                  <i
                    className="fa-solid fa-check"
                    style={{ color: "#23a1ab", marginRight: 8 }}
                  />
                  {perk}
                </li>
              ))}
            </ul>

          {/* Pricing Table (Hourly Cost Only) */}
<table
  style={{
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 30,
    fontSize: 15,
  }}
>
  <thead>
    <tr style={{ backgroundColor: "#23a1ab", color: "#fff" }}>
      <th style={{ padding: 12 }}>Role Type</th>
      <th style={{ padding: 12 }}>In-House Cost (Est.)</th>
      <th style={{ padding: 12 }}>Your Cost</th>
      <th style={{ padding: 12 }}>Savings</th>
    </tr>
  </thead>
  <tbody>
    <tr style={{ backgroundColor: "#f1f1f1" }}>
      <td style={{ padding: 12 }}>Software Engineer</td>
      <td style={{ padding: 12 }}>$50/hr</td>
      <td style={{ padding: 12 }}>$15/hr</td>
      <td
        style={{
          padding: 12,
          color: "#198754",
          fontWeight: "bold",
        }}
      >
        70%
      </td>
    </tr>

    <tr style={{ backgroundColor: "#fff" }}>
      <td style={{ padding: 12 }}>QA Specialist</td>
      <td style={{ padding: 12 }}>$31/hr</td>
      <td style={{ padding: 12 }}>$9/hr</td>
      <td
        style={{
          padding: 12,
          color: "#198754",
          fontWeight: "bold",
        }}
      >
        70%
      </td>
    </tr>
  </tbody>
</table>

          </div>
        </div>
      </section>

      {/* Pricing Quote Section */}
      <section
        className="pricing-quote-section section_space bg-light"
        style={{ padding: "60px 0" }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT: FORM */}
            <div className="col-lg-7 mb-4 mb-lg-0">
              <div className="quote-form-box p-4 bg-white shadow rounded">
                <div className="heading_block mb-3">
                  <div
                    className="heading_focus_text has_underline d-inline-flex"
                    style={{
                      backgroundImage:
                        'url("assets/images/shapes/shape_title_under_line.svg")',
                    }}
                  >
                    Instant Quote
                  </div>
                  <h2
                    className="heading_text mb-0"
                    style={{ fontSize: "2rem", fontWeight: 700 }}
                  >
                    Unlock Your Custom Pricing
                  </h2>
                  <p
                    className="heading_description mb-0"
                    style={{ color: "#555" }}
                  >
                    Get a transparent, no-obligation quote for your remote
                    staffing needs. Adjust the slider to estimate your monthly
                    cost based on your requirements.
                  </p>
                </div>

                {/* Functional Slider */}
                <div
                  className="slider-label mb-3 position-relative"
                  style={{ fontSize: "1rem", fontWeight: 600, height: 48 }}
                >
                  <span
                    className="d-inline-block px-3 py-2 border rounded position-absolute"
                    style={{
                      background: "#f5f7fa",
                      border: "2px solid var(--bs-primary)",
                      minWidth: 80,
                      textAlign: "center",
                      top: 0,
                      left: `${(sliderValue / 200) * 100}%`,
                      transform: "translateX(-50%)",
                      transition: "left 0.3s",
                    }}
                  >
                    ${sliderValue}k
                  </span>
                </div>

                <input
                  type="range"
                  id="pricingSlider"
                  className="slider w-100 mb-3"
                  min={0}
                  max={200}
                  value={sliderValue}
                  onChange={handleSliderChange}
                  style={{
                    accentColor: "var(--bs-primary)",
                    cursor: "pointer",
                  }}
                />

                <div
                  className="d-flex justify-content-between mb-4"
                  style={{ fontSize: "0.95rem", color: "#888" }}
                >
                  <span>$0k</span>
                  <span>$50k</span>
                  <span>$100k</span>
                  <span>$150k</span>
                  <span>$200k</span>
                </div>

                {/* Form Fields */}
                <form className="row g-3">
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone Number"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <select id="input_service" name="service" required className="form-select">
                      <option value="" disabled selected>
                        Choose a service...
                      </option>
                      <option>Dedicated Developers</option>
                      <option>QA & Testing</option>
                      <option>DevOps & Cloud Engineers</option>
                      <option>AI / Machine Learning</option>
                      <option>SEO Optimization</option>
                      <option>Content Writing</option>
                      <option>Admin Support</option>
                      <option>Customer Support</option>
                    </select>
                  </div>
                  <div className="col-12 mt-2">
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      style={{ fontWeight: 600 }}
                    >
                      <span className="btn_label">Get My Quote</span>
                      <span className="btn_icon ms-2">
                        <i className="fa-solid fa-arrow-up-right" />
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* RIGHT: TESTIMONIAL */}
            <div className="col-lg-5">
              <div
                className="testimonial-box p-5 bg-primary text-white rounded shadow d-flex flex-column align-items-center justify-content-center"
                style={{
                  minHeight: 440,
                  maxWidth: "100%",
                  boxShadow: "0 8px 32px rgba(44,62,80,0.12)",
                  borderRadius: "1.25rem",
                }}
              >
                <div
                  className="testimonial-img mb-3"
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "4px solid #fff",
                    background: "#eee",
                  }}
                >
                  <img
                    src="assets/images/avatar/client 1.jpg"
                    alt="Roman Dymtro"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
                <h4
                  className="mb-2"
                  style={{ fontWeight: 800, fontSize: "2rem", letterSpacing: "0.5px" }}
                >
                  Roman Dymtro
                </h4>
                <p
                  className="mb-0"
                  style={{
                    fontSize: "1.35rem",
                    fontWeight: 500,
                    lineHeight: "1.7",
                    textAlign: "center",
                    maxWidth: 420,
                  }}
                >
                  “                  <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span> is extremely talented and delivered the project
                  on time and on budget. I would definitely recommend <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span> for any machine learning project you need help with!"”
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Form;
